import callApi from '../../util/apiCaller';
import { addError } from '../Error/ErrorActions';

// Export Constants
export const SET_ADDRESSES = 'SET_ADDRESSES';
export const REMOVE_ADDRESS = 'REMOVE_ADDRESS';

// Export Actions

export function getAddressesRequest(userId = null) {
    return dispatch => {
        return callApi(`addresses${userId ? `/${userId}` : ''}`).then(res => {
            if(res.addresses) {
                dispatch(setAddresses(res.addresses));
            }
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function editAddressRequest(address) {
    return dispatch => {
        return callApi('address/edit', 'post', { address }).then(res => {
            if(res.address) {
                dispatch(setAddresses([res.address]));
                return res.address;
            }
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function setInvoiceAddressRequest(address) {
    return dispatch => {
        return callApi('address/useforinvoice', 'post', { address }).then(res => {
            if(res.ok) {
                dispatch(getAddressesRequest());
                return res.ok;
            }
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function deleteAddressRequest(addressId) {
    return dispatch => {
        return callApi('address/remove', 'post', { address: { _id: addressId } }).then(res => {
            if(res.ok) {
                dispatch(removeAddress(addressId));
            }
            return res.ok;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}


export function getAddress(store, addressId) {
    return store.addresses.data.find(address => address._id === addressId);
}

export function getAddresses(store, userId = null) {
    return store.addresses.data.filter(address => {
        const addressUserId = address.user._id || address.user;
        return !userId || addressUserId === userId;
    });
}

export function getInvoiceAddress(store, userId) {
    const userAddresses = getAddresses(store, userId);
    const invoiceAddress = userAddresses.find(address => address.isUsedForInvoice);
    if(!invoiceAddress) {
        return userAddresses && userAddresses[0];
    }
    return invoiceAddress;
}

export function setAddresses(addresses) {
    return {
        type: SET_ADDRESSES,
        addresses,
    };
}
export function removeAddress(addressId) {
    return {
        type: REMOVE_ADDRESS,
        addressId,
    };
}
